import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/Accordion';
import { Button } from './ui/Button';
import { Phone, CreditCard, ClipboardList, Wrench, ArrowRight, Mail } from 'lucide-react';
import { AnimateOnScroll } from './AnimateOnScroll';
export function FAQSection() {
  const faqs = [{
    question: 'How do I apply for a rental property?',
    answer: "You can browse our available listings and submit an application online. We typically process applications within 2–3 business days. You'll need to provide proof of income, identification, and references."
  }, {
    question: 'What are your management fees?',
    answer: 'Our management fees are competitive and transparent. We offer customized pricing based on your property type and needs. Contact us for a free consultation and detailed quote.'
  }, {
    question: 'How do I pay rent online?',
    answer: 'Tenants can pay rent through our secure online portal. Simply log in to your account, navigate to the payments section, and follow the prompts. We accept ACH transfers and credit/debit cards.'
  }, {
    question: 'How do I submit a maintenance request?',
    answer: 'You can submit maintenance requests 24/7 through our online portal or by calling our office. Emergency maintenance issues are handled with priority response times.'
  }, {
    question: 'What areas do you serve?',
    answer: 'We proudly serve Fresno and the greater Central Valley area, including Clovis, Madera, Sanger, Selma, and surrounding communities.'
  }];
  return <section className="py-24 bg-background" data-id="element-11">
      <div className="container mx-auto px-4" data-id="element-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start" data-id="element-13">
          {/* Left: Heading + CTA */}
          <div className="lg:sticky lg:top-40" data-id="element-14">
            <AnimateOnScroll data-id="element-15">
              <p className="text-[oklch(0.45_0.16_250)] font-medium text-sm uppercase tracking-widest mb-3" data-id="element-16">
                Support
              </p>
              <h2 className="font-heading text-3xl md:text-4xl font-medium text-foreground mb-4" data-id="element-17">
                Frequently Asked Questions
              </h2>
              <p className="text-muted-foreground text-lg mb-8 leading-relaxed" data-id="element-18">
                Can't find what you're looking for? Our team is always happy to
                help.
              </p>
            </AnimateOnScroll>

            {/* Quick action cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4" data-id="element-19">
              <AnimateOnScroll delay={0.1} data-id="element-20">
                <a href="#" className="group flex items-start gap-3.5 p-4 rounded-xl bg-white border border-border/60 hover:border-primary/30 hover:shadow-lg transition-all duration-200" data-id="element-21">
                  <div className="p-2.5 rounded-lg bg-muted group-hover:bg-primary group-hover:text-primary-foreground transition-all duration-200 shrink-0" data-id="element-22">
                    <CreditCard className="h-5 w-5" data-id="element-23" />
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-24">
                    <div className="text-sm font-medium text-foreground mb-0.5" data-id="element-25">
                      Pay Rent
                    </div>
                    <div className="text-xs text-muted-foreground leading-relaxed" data-id="element-26">
                      Secure monthly rent payments online
                    </div>
                  </div>
                  <ArrowRight className="h-4 w-4 text-muted-foreground group-hover:text-primary group-hover:translate-x-0.5 transition-all duration-200 mt-1 shrink-0" data-id="element-27" />
                </a>
              </AnimateOnScroll>

              <AnimateOnScroll delay={0.15} data-id="element-28">
                <a href="#" className="group flex items-start gap-3.5 p-4 rounded-xl bg-white border border-border/60 hover:border-primary/30 hover:shadow-lg transition-all duration-200" data-id="element-29">
                  <div className="p-2.5 rounded-lg bg-muted group-hover:bg-primary group-hover:text-primary-foreground transition-all duration-200 shrink-0" data-id="element-30">
                    <ClipboardList className="h-5 w-5" data-id="element-31" />
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-32">
                    <div className="text-sm font-medium text-foreground mb-0.5" data-id="element-33">
                      Pay HOA Fees
                    </div>
                    <div className="text-xs text-muted-foreground leading-relaxed" data-id="element-34">
                      Association dues & assessments
                    </div>
                  </div>
                  <ArrowRight className="h-4 w-4 text-muted-foreground group-hover:text-primary group-hover:translate-x-0.5 transition-all duration-200 mt-1 shrink-0" data-id="element-35" />
                </a>
              </AnimateOnScroll>

              <AnimateOnScroll delay={0.2} className="sm:col-span-2" data-id="element-36">
                <a href="#" className="group flex items-start gap-3.5 p-4 rounded-xl bg-white border border-border/60 hover:border-primary/30 hover:shadow-lg transition-all duration-200" data-id="element-37">
                  <div className="p-2.5 rounded-lg bg-muted group-hover:bg-primary group-hover:text-primary-foreground transition-all duration-200 shrink-0" data-id="element-38">
                    <Wrench className="h-5 w-5" data-id="element-39" />
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-40">
                    <div className="text-sm font-medium text-foreground mb-0.5" data-id="element-41">
                      Maintenance Request
                    </div>
                    <div className="text-xs text-muted-foreground leading-relaxed" data-id="element-42">
                      Submit & track repair requests 24/7
                    </div>
                  </div>
                  <ArrowRight className="h-4 w-4 text-muted-foreground group-hover:text-primary group-hover:translate-x-0.5 transition-all duration-200 mt-1 shrink-0" data-id="element-43" />
                </a>
              </AnimateOnScroll>
            </div>

            <AnimateOnScroll delay={0.25} data-id="element-44">
              <div className="bg-primary rounded-2xl p-6 text-primary-foreground" data-id="element-45">
                <p className="font-heading font-medium text-lg mb-1" data-id="element-46">
                  Still have questions?
                </p>
                <p className="text-primary-foreground/70 text-sm mb-5" data-id="element-47">
                  Our team responds within one business day.
                </p>
                <div className="flex flex-wrap gap-3" data-id="element-48">
                  <Button variant="secondary" className="gap-2 h-11 px-5 text-sm font-medium bg-primary-foreground/15 text-primary-foreground border border-primary-foreground/20 hover:bg-primary-foreground/25 hover:text-primary-foreground" data-id="element-49">
                    <Phone className="h-4 w-4" data-id="element-50" />
                    (559) 486-5600
                  </Button>
                  <Button variant="secondary" className="gap-2 h-11 px-5 text-sm font-medium bg-primary-foreground/15 text-primary-foreground border border-primary-foreground/20 hover:bg-primary-foreground/25 hover:text-primary-foreground" data-id="element-51">
                    <Mail className="h-4 w-4" data-id="element-52" />
                    Email Us
                  </Button>
                </div>
              </div>
            </AnimateOnScroll>
          </div>

          {/* Right: Accordion */}
          <div data-id="element-53">
            <Accordion type="single" collapsible className="w-full" data-id="element-54">
              {faqs.map((faq, index) => <AnimateOnScroll key={index} delay={index * 0.08} data-id="element-55">
                  <AccordionItem value={`item-${index}`} className="border-b border-border/60" data-id="element-56">
                    <AccordionTrigger className="text-left font-heading text-base md:text-lg font-medium hover:text-primary py-5" data-id="element-57">
                      {faq.question}
                    </AccordionTrigger>
                    <AccordionContent className="text-base text-muted-foreground leading-relaxed pb-5" data-id="element-58">
                      {faq.answer}
                    </AccordionContent>
                  </AccordionItem>
                </AnimateOnScroll>)}
            </Accordion>
          </div>
        </div>
      </div>
    </section>;
}